import { AntSteps } from './styles'

export default AntSteps
